export default __webpack_public_path__ + "static/logo3-dd2b76ce38e5926b42ed8f3c9f2602c5.png";